const setToast = (boolean, severity, content) => {
  return {
    type: "SET_TOAST",
    payload: {
      toast: boolean,
      severity,
      content,
    },
  };
};

export { setToast };
